<template>
    <modal class="takeOutSpecialOrderModel" :isShow="isShow" isMask @click="hide()" @keyup.esc="hide">
        <div class="header">外卖平台异常订单
            <i class="close-bnt iconfont icon-a-bg-close3x" @click="hide()"></i>
        </div>
        <div class="modal-body">
            <div class="filter-box">
                <div class="inline-block search-box">
                    外卖平台:
                </div>
                <div class="nav-box" >
                    <div class="nav-li" :class="{selected:channelName==null}" @click="channelName=null">全部</div>
                    <div class="nav-li" :class="{selected:channelName==item.PLATKINDNAME}" @click="channelName=item.PLATKINDNAME" v-for="item in takePlatDic" :key="item">
                        {{item.PLATKINDNAME}}<span class="tip-num" v-show="tipTotalNum[item.PLATKINDNAME]>0">{{tipTotalNum[item.PLATKINDNAME]}}</span> 
                    </div>
                </div>
            </div>
            <div class="data-box">
                <div class="table-box">
                    <div class="table-tbody">
                        <div class="tr" :class="{selected:item.PlatOrder_ID==currentData?.PlatOrder_ID}" v-for="item in pageList" :key="item" @click="currentClick(item)">
                            <div class="flex-1">
                                <div class="column-box">
                                    <div class="column">{{item.Channel_Name}}</div>
                                    <div class="column">
                                        <span class="lable-text">流水号:</span>
                                        <span class="input-text"><span class="unit">#</span>{{item.ThirdSn}}</span>
                                    </div>
                                </div>
                                <div class="content-box">
                                    <div class="column">
                                        <span class="lable-text">平台单号:</span>
                                        <span class="input-text">{{item.PlatOrder_No}}</span>
                                    </div>
                                    <div class="column">
                                        <span class="lable-text">订单时间:</span>
                                        <span class="input-text">{{dateFormat(item.Order_Date)}}</span>
                                    </div>
                                    <div class="column">
                                        <span class="lable-text">单据状态:</span>
                                        <span class="red">{{{"-2":"平台已退单，推送POS失败",0:"未处理新订单",1:"已拉取订单"}[item.ProcessStatus]}}</span>
                                    </div>
                                </div>
                                <div class="column-flex-box column">
                                    <div class="lable-text">备注信息:</div>
                                    <el-tooltip  effect="dark" trigger="click" :content="item.ProcessMsg" placement="top">
                                        <span class="input-text nowrap2">
                                        {{item.ProcessMsg}}
                                        </span> 
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="bnt bnt-push" @click.stop="push(item)">推送<br/>POS</div>
                        </div>
                    </div>
                </div>
                <div class="footer-box">
                    <div class="page-box">
                        <span>当前第 {{tablePageIndex}} 页 &nbsp;&nbsp; 共{{tablePageSum}}页</span>
                        <div class="page-button">
                            <page-Turning class="but but-up" type="up" v-model="tablePageIndex" :pageCount="tablePageSum">上一页</page-Turning>
                            <page-Turning class="but but-down" type="down" v-model="tablePageIndex" :pageCount="tablePageSum">下一页</page-Turning>
                        </div>
                    </div>
                    <button class="btn" @click="push()">全部推送POS</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
// 来电记录
export default {
    name:'callCheckNumModel',
    emits:["close"],
    props:{
        isShow:Boolean,
    },
    data(){
        return{
            //平台筛选 条件
            channelName:null,
            //外卖平台筛选数据
            takePlatDic:[],
            //排序
            sortable:null,
            //订单数据
            tableList:[],
            //选中的数据
            currentData:null,
            tablePageIndex:1,
            tablePageSize:6,
        }
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.init();
            }
        },
        tableFilter(){
            this.tablePageIndex=1;
        }
    },
    computed:{
        //检索
        tableSearch(){
            let list=this.tableList||[];
            if(this.channelName){
                list=list.filter((item)=> item.Channel_Name=this.channelName);
            }
            return list;
        },
        /**筛选数据 */
        tableFilter(){
            let list=Object.assign([],this.tableSearch);
            //排序
            if(this.sortable){
                let sorttype=this.sortable.order=='ascending'?'asc':'desc';
                list.order(this.sortable.prop,sorttype);
            }else if(this.navType==1){
                //结账时间 顺序
                list.order("Eat_ETime",'asc');
            }else if(this.navType==2){
                //核销时间 倒序
                list.order("Eat_Operatortime",'desc');
            }
            return list;
        },
        tipTotalNum(){
            let total={};
            this.tableList?.forEach(it=>{
                if(total[it.Channel_Name]!=undefined){
                    total[it.Channel_Name]++;
                }else{
                    total[it.Channel_Name]=1;
                }
            })
            return total;
        },
        /**分页数据 */
        pageList(){
            if(this.tableFilter && this.tableFilter.length>0){
                return this.tableFilter.slice((this.tablePageIndex-1)*this.tablePageSize,this.tablePageIndex*this.tablePageSize);
            }
            return [];
        },
        //表格数据 分页总页数 
        tablePageSum(){
            let lenth=1;
            if(this.tableFilter && this.tableFilter.length>0){
                lenth=Math.ceil(this.tableFilter.length/this.tablePageSize)||1;
            }
            return lenth;
        }
    },
    mounted(){
        
        this.$nextTick(()=>{
            this.init();
        });
    },
    methods:{
        /**初始化数据 */
        init(){
            this.channelName=null;
            this.currentData=null;
            if(this.takePlatDic?.length==0){
                //外卖平台筛选数据
                this.$cacheData.TakePlatDic().then(d=>{
                    this.takePlatDic=d||[];
                }).catch(e=>{
                    console.log('e:'+e)
                    this.$message.error('未找外卖平台筛选数据');
                })
            }
            this.loadList();
        },
        hide(){
            this.$emit("close");
        },
        confirm(){
        },
        /*时间格式 */
        dateFormat(cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd');
        },
        //点击排序
        sortChange(prop){
            console.log(prop)
            if(this.sortable?.prop==prop){
                if(this.sortable.order=="ascending"){
                    this.sortable.order='descending';
                }else if(this.sortable.order=="descending"){
                    this.sortable=null;
                }
            }else{
                this.sortable={
                    prop:prop,
                    order:"ascending"
                }
            }
            
        },
        /**加载订单数据 */
        loadList(){
            let userInfo=this.$auth.getUserInfo();
            this.tablePageIndex=1;
            const loading = this.$loading({
                text: "数据加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.platformPost("Bestech.Platform.Takeout.GetExceptionOrders",{
                User_ID:userInfo.User_ID, //登陆用户ID
                Mer_ID:userInfo.Mer_ID,//商户id
                Department_ID:userInfo.Department_ID 
            }).then((d)=>{
                loading.close();
                console.log(d)
                if(d.ResponseHeader.ResultCode==0){
                    this.tableList=d.ResponseBody||[];
                }else{
                    this.tableList=[];
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableList=[];
                loading.close();
                this.$message.error("加载订单数据失败："+e.message);
                console.log('加载订单数据失败：',e);
            })
        },
        currentClick(item){
            this.currentData=item;
            
        },
        //推送POS
        push(item){
            let pushOrder=[]
            if(item){
                pushOrder.push({
                    ProcessStatus:item.ProcessStatus,
                    Takeout_AutoID:item.Takeout_AutoID
                })
            }else{
                this.tableList?.forEach(it=>{
                    pushOrder.push({
                        ProcessStatus:it.ProcessStatus,
                        Takeout_AutoID:it.Takeout_AutoID
                    })
                })
            }
            if(pushOrder.length==0){
                this.$message.warning("没有可推送的数据");
                return;
            }
            const loading = this.$loading({
                text: "推送数据请求中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo=this.$auth.getUserInfo();
            this.$httpAES.platformPost("Bestech.Platform.Takeout.RepushExceptionOrders",{
                User_ID:userInfo.User_ID, //登陆用户ID
                Mer_ID:userInfo.Mer_ID,//商户id
                ExceptionOrders:pushOrder
            }).then((d)=>{
                console.log(d);
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error("推送失败"+d.ResponseHeader.ResultDesc);
                    return;
                }
                this.$message.success("推送成功");
                if(item){
                    let index=this.tableList.findIndex(it=>it.Takeout_AutoID==item.Takeout_AutoID);
                    if(index>=0){
                        this.tableList.splice(index,1);
                    }
                }else{
                    this.tableList=[];
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "推送失败", {confirmButtonText: "确定"});
            })
        },
        
    }
}
</script>

<style lang="scss">
@import './takeOutSpecialOrderModel.scss'
</style>